import { GatewayTransactionType } from "common/graphql/queries/GetCurbsuiteTransactions";

// Only the gateway transaction types that can appear on a wallet transaction row (payout belongs
// to other views) -- keep in sync with the values Hasura's financial_gateway_transaction_type_enum accepts.
// Adjustment rows (AUT-6163) have no gateway transaction, so they're labelled by ADJUSTMENT_TYPE_LABEL
// rather than through this map.
export const WALLET_TRANSACTION_TYPE_LABELS: Partial<Record<GatewayTransactionType, string>> = {
  wallet_reload: "Wallet Reload",
  initial_wallet_load: "New Account",
  wallet_refund: "Wallet Refund",
  session_payment: "Session Payment",
  permit: "Permit Transactions",
};
